import { Box, TabBar } from '@ksyos/design-system';
import { useLocation, useNavigate } from '@ksyos/router';

type TabbedSection = {
    pages: {
        content: JSX.Element;
        title: string;
        url: string;
    }[];
};

export function TabbedSection(props: Readonly<TabbedSection>) {
    const { pages } = props;

    const navigate = useNavigate();
    const location = useLocation();

    return (
        <>
            {pages.length > 1 && (
                <TabBar>
                    {props.pages.map(({ title, url }) => (
                        <TabBar.Button
                            isSelected={location.pathname === url}
                            key={url}
                            onClick={() => navigate(url)}
                        >
                            {title}
                        </TabBar.Button>
                    ))}
                </TabBar>
            )}

            <Box>
                {props.pages.map(({ content, url }) => location.pathname === url && <div key={url}>{content}</div>)}
            </Box>
        </>
    );
}
